export default {"src":"/_next/static/media/stakeholder-engagement.7e1e5b05.svg","height":782,"width":976,"blurWidth":0,"blurHeight":0};